/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Filter_Last_DaysInputs */

const en_ui_filter_last_days = /** @type {(inputs: Ui_Filter_Last_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last ${i?.count} days`)
};

const de_ui_filter_last_days = /** @type {(inputs: Ui_Filter_Last_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`letzte ${i?.count} Tage`)
};

/**
* | output |
* | --- |
* | "last {count} days" |
*
* @param {Ui_Filter_Last_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_days = /** @type {((inputs: Ui_Filter_Last_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_days(inputs)
	return de_ui_filter_last_days(inputs)
});